var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BACKDROP } from '../overlays';
import { getLinkTag, getScriptModuleTag, getScriptNoModuleTag } from './of-popup-utils';
import { fin } from '@openfin/core';
function isMacOs() {
    const regexp = /Macintosh/;
    return regexp.test(navigator.userAgent);
}
export function getWindowByName(name) {
    return __awaiter(this, void 0, void 0, function* () {
        const app = fin.Application.getCurrentSync();
        return (yield app.getChildWindows()).find((win) => win.identity.name === name);
    });
}
export function dismissWindow() {
    return __awaiter(this, void 0, void 0, function* () {
        const win = yield fin.Window.getCurrent();
        const { customData } = yield win.getOptions();
        const el = win.getWebWindow().document.querySelector(customData.elementTag);
        el && (el.isWindowFocused = false);
        if (!(el === null || el === void 0 ? void 0 : el.isInputFocused) && customData.canBlurDismiss) {
            el === null || el === void 0 ? void 0 : el.dismiss(BACKDROP, undefined);
        }
    });
}
function handleFocusWindow() {
    return __awaiter(this, void 0, void 0, function* () {
        const win = yield fin.Window.getCurrent();
        const { customData } = yield win.getOptions();
        const el = win.getWebWindow().document.querySelector(customData.elementTag);
        el && (el.isWindowFocused = true);
    });
}
export function createWindow(name, elementTag, popupDimensions, namespace, canBlurDismiss = true) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        let win = yield getWindowByName(`alk-of-popup-${name}`);
        const { width, height, maxHeight } = popupDimensions;
        if (!Boolean(win)) {
            win = yield fin.Window.create({
                name: `alk-of-popup-${name}`,
                url: 'alk-of-popup.html',
                defaultWidth: Math.round(width),
                defaultHeight: Math.round(height),
                maxHeight: Math.round(maxHeight),
                cornerRounding: { height: 0, width: 0 },
                contextMenu: false,
                backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--ion-background-color'),
                saveWindowState: false,
                includeInSnapshots: false,
                alwaysOnTop: true,
                autoShow: false,
                frame: false,
                resizable: false,
                shadow: true,
                showTaskbarIcon: false,
                waitForPageLoad: true,
                customData: {
                    elementTag,
                    canBlurDismiss,
                },
            });
            const doc = win.getWebWindow().document;
            const appNamespace = (_a = doc.documentElement.getAttribute('data-fnx-namespace')) !== null && _a !== void 0 ? _a : namespace;
            doc.head.appendChild(getLinkTag(appNamespace, doc));
            doc.head.appendChild(getScriptModuleTag(appNamespace, doc));
            doc.head.appendChild(getScriptNoModuleTag(appNamespace, doc));
            doc.body.appendChild(doc.createElement(elementTag));
        }
        return win.getWebWindow().document.querySelector(elementTag);
    });
}
export function show(event, dimensions, popupDimensions) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { width, height, maxHeight } = popupDimensions;
        const win = yield fin.Window.getCurrent();
        yield win.updateOptions({ maxHeight });
        yield win.resizeTo(Math.round(width), Math.round(height), 'top-left');
        yield win.addListener('blurred', dismissWindow);
        yield win.addListener('focused', handleFocusWindow);
        const viewPosition = event.view;
        // availLeft and availTop are not yet present on the Screen interface even if we can use it
        // They represent the position of the top left corner of the current screen compared to the main screen
        // On the main screen they are set to zero
        const screenAvailLeft = (_a = viewPosition.screen['availLeft']) !== null && _a !== void 0 ? _a : 0;
        let xPos = viewPosition.screenLeft + dimensions.left;
        // Limit min x position
        xPos = Math.max(xPos, screenAvailLeft);
        // Limit max x position
        xPos = Math.min(xPos, screenAvailLeft + viewPosition.screen.width - popupDimensions.width);
        const screenAvailTop = (_b = viewPosition.screen['availTop']) !== null && _b !== void 0 ? _b : 0;
        let yPos = viewPosition.screenTop + dimensions.top + (isMacOs() ? 23 : 1);
        // Limit min y position
        yPos = Math.max(yPos, screenAvailTop);
        // Limit max y position
        yPos = Math.min(yPos, screenAvailTop + viewPosition.screen.height - popupDimensions.maxHeight);
        yield win.showAt(xPos, yPos, false);
        yield win.setAsForeground();
    });
}
export function hide() {
    return __awaiter(this, void 0, void 0, function* () {
        const win = yield fin.Window.getCurrent();
        yield win.removeListener('blurred', dismissWindow);
        yield win.removeListener('focused', handleFocusWindow);
        return win.hide();
    });
}
